// @flow
export const INTERCOM_APP_ID = 'zv2srpe5'
export const GOOGLE_ANALYTICS_TRACKING_ID = 'G-KZLZEV9EJ5'
export const isProductionApp: boolean =
	window.location.origin === 'https://app-beta.smsleopard.com' || window.location.origin === 'https://app.smsleopard.com'
export const INACTIVE_SESSION_ERROR_CODE = 'invalid_session_status'
